export const GLOBAL_ACTIONS_LABELS = 'global.actions';
export const lblApplyNow = `lbl_apply_now`;
export const lblRemove = `lbl_remove`;
export const lblApply = `lbl_apply`;
export const lblApplying = `lbl_applying`;
export const lblRemoving = `lbl_removing`;
export const lblRemoveCaps = `lbl_remove_caps`;
export const lblCancel = `lbl_cancel`;
export const lblCancelCaps = `lbl_cancel_caps`;
export const lblSaveCaps = `lbl_save_caps`;
export const lblSaveForLater = `lbl_save_for_later`;
export const lblSubmit = `lbl_submit`;
export const lblUpdate = `lbl_update`;
export const lblUpdateCaps = `lbl_update_caps`;
export const lblCheckout = `lbl_checkout`;
export const lblEdit = `lbl_edit`;
export const lblCreateAccount = `lbl_createAccount`;
export const lblLogin = `lbl_login`;
export const lblBack = `lbl_back`;
export const lblEditOrSaveLater = `lbl_edit_or_save_later`;
export const lblTapHere = `lbl_tap_here`;

export const GlobalActionsLabels = {
  global: {
    actions: {
      [lblApplyNow]: 'Apply Now',
      [lblRemove]: 'Remove',
      [lblApply]: 'Apply',
      [lblApplying]: 'Applying',
      [lblRemoving]: 'Removing',
      [lblRemoveCaps]: 'REMOVE',
      [lblCancel]: 'Cancel',
      [lblCancelCaps]: 'CANCEL',
      [lblSaveCaps]: 'SAVE',
      [lblSaveForLater]: 'Save For Later',
      [lblSubmit]: 'Submit',
      [lblUpdate]: 'Update',
      [lblUpdateCaps]: 'UPDATE',
      [lblCheckout]: 'Checkout',
      [lblEdit]: 'Edit',
      [lblCreateAccount]: 'Create Account',
      [lblLogin]: 'Log In',
      [lblBack]: 'Back',
      [lblEditOrSaveLater]:
        '<style>.bold { font-weight:800}</style>To <span class="bold">edit</span> or <span class="bold">save for later</span>,',
      [lblTapHere]: 'tap here!',
    },
  },
};
